import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillTwitterCircle,
  AiFillYoutube,
} from 'react-icons/ai';
import {
  Box, Flex, Heading, Text, Divider,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';

import { ExternalLinkIcon } from '@chakra-ui/icons';

import PropTypes from 'prop-types';
import { SiZillow } from 'react-icons/si';
import { generate } from 'shortid';
import moment from 'moment';
import { GatsbyImage } from 'gatsby-plugin-image';
import Logo from '../../assets/mark/mark-enhanced.svg';
import { LinkEmail, LinkOne, LinkPhone } from '../_index';

const hours = [];

const social = [
  {
    name: 'Facebook',
    link: 'https://www.facebook.com/WeBuyHousesInBayArea/',
    icon: <AiFillFacebook />,
  },
  {
    name: 'YouTube',
    link: 'https://www.youtube.com/channel/UCGVj8wl5WyoRCVueIj9uZwQ?sub_confirmation=1',
    icon: <AiFillYoutube />,
  },
  {
    name: 'Instagram',
    link: 'https://www.instagram.com/webuyhousesinbay.area/',
    icon: <AiFillInstagram />,
  },
  {
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/company/we-buy-houses-in-bay-area/',
    icon: <AiFillLinkedin />,
  },
  {
    name: 'Zillow',
    link: 'https://www.zillow.com/profile/WeBuyHousesInBayArea/',
    icon: <SiZillow />,
  },
  {
    name: 'Twitter',
    link: 'https://twitter.com/WeBuyHousesInBA',
    icon: <AiFillTwitterCircle />,
  },
];

const links = [
  {
    name: 'Home',
    to: '/',
    id: generate(),
  },
  {
    name: 'Reviews',
    to: '/reviews',
    id: generate(),
  },
  {
    name: 'How It Works',
    to: '/how-it-works',
    id: generate(),
  },
  {
    name: 'About us',
    to: '/about',
    id: generate(),
  },
  {
    name: 'Blog',
    to: '/blog',
    id: generate(),
  },
  {
    name: 'FAQ',
    to: '/faq',
    id: generate(),
  },
];

const Footer = ({ title, description, location }) => {
  const { pathname } = location;
  const { site } = useStaticQuery(query);

  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    siteUrl,
    baseUrl,
    contactEmail,
    defaultImage,
    phone,
    address,
    twitterUsername,
  } = site.siteMetadata;

  const data = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname}`,
  };
  return (
    <footer>
      <Box
        background="white"
        py={10}
      >
        <Divider />
        <Box>
          <Flex
            minHeight="100%"
            flexDirection={{
              base: 'row',

              md: 'row',
            }}
            flexWrap="wrap"
            justifyContent="space-between"
          >
            <Box
              flexGrow="1"
              flexBasis={{ base: '40%', md: 'auto' }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                px={{ base: 2, sm: 6 }}
                pt={{ base: 10, md: 20 }}
              >
                <Heading
                  as="h4"
                  size="md"
                  mb={6}
                  variant="sec"
                >
                  Links
                </Heading>

                <Flex
                  flexDirection="column"
                  mr={4}
                >
                  {links.map((l, i) => (
                    <LinkOne
                      mb={2}
                      fontSize="sm"
                      key={l.id}
                      to={l.to}
                    >
                      {' '}
                      {l.name}
                      {' '}
                    </LinkOne>
                  ))}
                </Flex>
              </Box>
            </Box>
            <Box
              flexGrow="1"
              flexBasis={{ base: '40%', md: 'auto' }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                px={{ base: 2, sm: 6 }}
                pt={{ base: 10, md: 20 }}
              >
                <Heading
                  as="h4"
                  size="md"
                  mb={6}
                  variant="sec"
                >
                  Social
                </Heading>
                <Flex flexDirection="row">
                  <Flex
                    flexDirection="column"
                    mr={4}
                  >
                    {social.slice(0, 3).map((s, i) => (
                      <LinkOne
                        mb={2}
                        fontSize="sm"
                        key={generate()}
                        href={s.link}
                        icon={(
                          <ExternalLinkIcon
                            opacity={0.5}
                            ml={2}
                          />
)}
                      >
                        <Flex alignItems="center">
                          <Box mr={2}>{s.icon}</Box>
                          {' '}
                          {s.name}
                          {' '}
                        </Flex>
                      </LinkOne>
                    ))}
                  </Flex>
                  <Flex flexDirection="column">
                    {social.slice(3).map((s, i) => (
                      <LinkOne
                        mb={2}
                        fontSize="sm"
                        key={generate()}
                        href={s.link}
                        icon={(
                          <ExternalLinkIcon
                            opacity={0.5}
                            ml={2}
                          />
)}
                      >
                        <Flex alignItems="center">
                          <Box mr={2}>{s.icon}</Box>
                          {' '}
                          {s.name}
                          {' '}
                        </Flex>
                      </LinkOne>
                    ))}
                  </Flex>
                </Flex>
              </Box>
            </Box>
            <Box
              flexGrow="1"
              flexBasis={{ base: '100%', md: 'auto' }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                px={{ base: 2, sm: 6 }}
                pt={{ base: 10, md: 20 }}
              >
                <Heading
                  as="h4"
                  size="md"
                  mb={6}
                  variant="sec"
                >
                  Contact
                </Heading>
                {/* <Box>
                  <Link to="/">
                    <Logo style={{ width: '200px', height: '80px' }} />
                  </Link>
                </Box> */}
                <Heading
                  as="h4"
                  size="sm"
                  mb={2}
                >
                  <LinkEmail>{contactEmail}</LinkEmail>
                </Heading>
                <LinkPhone>{phone}</LinkPhone>
              </Box>
            </Box>

            <Box
              flexGrow="1"
              flexBasis={{ base: '100%', md: 'auto' }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                px={{ base: 2, sm: 6 }}
                pt={{ base: 10, md: 20 }}
              >
                <Heading
                  as="h4"
                  size="md"
                  mb={6}
                  variant="sec"
                >
                  Location
                </Heading>
                <Heading
                  as="h5"
                  size="sm"
                >
                  <a
                    href="geo:37.507910,-121.947050"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {' '}
                    {address}
                  </a>
                </Heading>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Box>
    </footer>
  );
};

Footer.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

Footer.defaultProps = {
  title: null,
  description: null,
};

const query = graphql`
  query {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl
        baseUrl
        contactEmail
        address
        defaultImage: image
        twitterUsername
        phone
      }
    }
  }
`;

export default Footer;
